import revisionNumber from "./ revisionNumber";
import timePeriodList from "./time-period";

export default [...timePeriodList, ...revisionNumber];
